import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { PhoneInputFieldWUT } from '../../../ui/phone-input-field';
export const DextPhoneWUT = props => {
  const fieldType = FIELD_TYPES.DEXT_PHONE;
  return /*#__PURE__*/React.createElement(PhoneInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=dext-phone-wut.js.map